import { Box, BoxProps } from '@material-ui/core';
import { WbTooltip } from '../../WbTooltip';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import GetApp from '@material-ui/icons/GetApp';
import { FC, Fragment } from 'react';
import { WbButton } from '../../WbButton';

interface ComparisonActionsProps {
  onCopyClick?: (arg: any) => Promise<void>;
  onDownloadClick?: () => void;
  beforeActions?: JSX.Element[];
  additionalActions?: JSX.Element[];
  style?: BoxProps;
}

export const ComparisonActions: FC<ComparisonActionsProps> = ({
  onCopyClick,
  onDownloadClick,
  additionalActions,
  beforeActions,
  style,
}) => {
  return (
    <Box style={{ ...style, display: 'flex', alignItems: 'center' }}>
      {beforeActions?.map(action => (
        <Fragment key={action.key}>{action}</Fragment>
      ))}
      {onCopyClick && (
        <WbTooltip title="Copy catalog-info.yaml from the right panel">
          <WbButton
            style={{
              marginRight: 20,
            }}
            onClick={onCopyClick}
            color="secondary"
            variant="text"
            label="Copy"
            icon={<FileCopyIcon />}
            iconColor="secondary"
          />
        </WbTooltip>
      )}
      {onDownloadClick && (
        <WbTooltip title="Download catalog-info.yaml from the right panel">
          <WbButton
            style={{
              marginRight: 20,
            }}
            onClick={onDownloadClick}
            color="secondary"
            variant="text"
            label="Download"
            icon={<GetApp />}
            iconColor="secondary"
          />
        </WbTooltip>
      )}
      {additionalActions?.map(action => (
        <Fragment key={action.key}>{action}</Fragment>
      ))}
    </Box>
  );
};
